import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=42a1b47b&"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports